
export default function StatsSection() {
  const stats = [
    { number: '12', label: '成約実績', unit: '件' },
    { number: '98', label: '顧客満足度', unit: '%' },
    { number: '45', label: '平均成約期間', unit: '日' },
    { number: '100', label: '成約後満足度', unit: '%' }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex items-end justify-center mb-2">
                <span className="text-5xl font-bold text-teal-600">{stat.number}</span>
                <span className="text-2xl font-semibold text-teal-600 mb-1">{stat.unit}</span>
              </div>
              <p className="text-gray-600 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
